
import React, { useEffect, useState,useRef } from 'react';

import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import api from '../../../../../../apis';
import Config from "../../../../../../config"

const LoginCarousel = () => {
    const [bannerList, setBannerList] = useState([]);
    const carouselRef = useRef();
    
    const [height, setHeight] = useState("auto");

    useEffect(() => {
        fetchBanner();
    }, []);


    // Update height on slide change
    const updateHeight = () => {
      if (carouselRef.current) {
        const activeSlide = carouselRef.current.innerSlider.list.querySelector(
          ".slick-slide.slick-active"
        );
        if (activeSlide) {
          setHeight(activeSlide.offsetHeight + "px");
        }
      }
    };
  
    useEffect(() => {
      updateHeight();
      window.addEventListener("resize", updateHeight);
      return () => window.removeEventListener("resize", updateHeight);
    }, []);
    

    const next = () => { 
      carouselRef.current.next();
    };
  
    const prev = () => {
      carouselRef.current.prev();
    };

    const fetchBanner = async ()=>{
        setBannerList([])
        let result = await api.getLoginBannerList({
        });

        console.log("result",result);

        if(result){
            setBannerList(result)
        }
    }




    return (
        <>
            <div className='loginCarousel custom-carousel '>
            <div style={{ height, transition: "height 0.3s ease" }}>
                <Carousel 
                    ref={carouselRef}
                    dots={false}
                    arrows={true}
                    autoplay
                    autoplaySpeed={5000}
                    afterChange={()=>{
                        updateHeight()
                    }}
               
               
                >

                    {bannerList.map((slide, index) => (
                        
                           
                                <img
                                    className="img-carousel "
                                    src={Config.utradeWebUrl+"/"+slide.source}
                                    alt={slide.name}
                                    onLoad={updateHeight} 
                                    onClick={()=>{
                                        if (slide.external_url) {
                                            window.open(slide.external_url, "_blank");
                                          }
                                    }}
                                />
                       
                        
                    ))}
                  
                </Carousel>
                <div className="custom-prev" onClick={prev}>
                    <LeftOutlined className='custom-arrow'/>
                </div>
                <div className="custom-next" onClick={next}>
                    <RightOutlined className='custom-arrow'/>
                </div>
                </div>
             
            </div>
         
        </>
    );
};

export default LoginCarousel;
